const ethers = require('ethers')

module.exports = { ethers }
